<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('user.feed.title')"
      :visible="visible"
      width="644px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <el-form :model="form" label-width="130px">
          <el-form-item :label="$t('user.feed.type')">
            <el-select style="width: 100%" placeholder="" v-model="form.select">
              <el-option :label="$t('user.feed.typeList.ecc')" value="1"></el-option>
              <el-option :label="$t('user.feed.typeList.bms')" value="2"></el-option>
              <el-option :label="$t('user.feed.typeList.mysql')" value="3"></el-option>
<!--              <el-option label="Redis" value="4"></el-option>-->
              <el-option :label="$t('user.feed.typeList.disk')" value="5"></el-option>
              <el-option :label="$t('user.feed.typeList.elb')" value="6"></el-option>
<!--              <el-option label="MongoDB" value="7"></el-option>-->
              <el-option :label="$t('user.feed.typeList.ip')" value="8"></el-option>
              <el-option :label="$t('user.feed.typeList.ssl')" value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('user.feed.fTitle')" required>
            <el-input type="text" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.feed.desc')" required>
            <el-input type="textarea"  :rows="3" v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.feed.email')" required>
            <el-input type="text" v-model="form.sendEmail"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{$t('user.feed.cancel')}}</el-button>
        <el-button type="primary" @click="submit">{{$t('user.feed.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        select: "",
        title: "",
        desc: "",
        email:''
      },
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
        if(n == false){
          this.form.select = '';
          this.form.title = '';
          this.form.sendEmail = '';
          this.form.desc = '';
        }
      },
    },
  },
  props: {},
  methods: {
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
    submit(){
      this.$http.post('/home/user/feedback', this.form).then((res) => {
        res = res.data
        if(res.code == 0){
          this.$message.success(res.message);
          this.visible = !this.visible;
        }else{
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.$util.handleErr(err);
      })
    }
  },
};
</script>

<style scoped lang="scss">
.title {
  font-size: 14px;
  font-weight: 500;
  color: #0f1e33;
  line-height: 14px;
  margin-bottom: 32px;
}
</style>
<style>
.oreder-modal-wrap .el-form-item__label {
  color: #5e6d81;
  font-size: 14px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Feedback.vue